import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  FaTachometerAlt, 
  FaDesktop, 
  FaHistory, 
  FaBell, 
  FaUserCog, 
  FaChartLine, 
  FaSignOutAlt,
  FaTimes,
  FaBars
} from 'react-icons/fa';

/**
 * 侧边栏组件 - 显示主导航菜单
 * @param {boolean} isOpen - 侧边栏是否打开
 * @param {function} toggleSidebar - 切换侧边栏状态的函数
 */
const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  
  // 导航菜单项
  const menuItems = [
    {
      title: '仪表盘',
      path: '/dashboard',
      icon: <FaTachometerAlt />
    },
    {
      title: '监控站点',
      path: '/sites',
      icon: <FaDesktop />
    },
    {
      title: '变更记录',
      path: '/changes',
      icon: <FaHistory />
    },
    {
      title: '通知中心',
      path: '/notifications',
      icon: <FaBell />
    },
    {
      title: '统计分析',
      path: '/analytics',
      icon: <FaChartLine />
    },
    {
      title: '个人设置',
      path: '/profile',
      icon: <FaUserCog />
    }
  ];

  // 判断菜单项是否激活
  const isActive = (path) => {
    if (path === '/dashboard' && location.pathname === '/dashboard') {
      return true;
    }
    
    if (path !== '/dashboard' && location.pathname.startsWith(path)) {
      return true;
    }
    
    return false;
  };

  // 处理退出登录
  const handleLogout = () => {
    logout();
  };

  return (
    <>
      {/* 移动端侧边栏切换按钮 */}
      <button 
        className="d-md-none btn btn-primary position-fixed start-0 top-50 translate-middle-y" 
        style={{ 
          zIndex: 1040, 
          borderTopLeftRadius: 0, 
          borderBottomLeftRadius: 0, 
          padding: '8px 5px' 
        }}
        onClick={toggleSidebar}
      >
        {isOpen ? <FaTimes size={18} /> : <FaBars size={18} />}
      </button>
      
      {/* 侧边栏 */}
      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="sidebar-content p-0 h-100 d-flex flex-column">
          {/* 侧边栏头部 */}
          <div className="sidebar-header p-3 d-flex justify-content-between align-items-center border-bottom">
            <h5 className="mb-0 text-white">WebChangeAI</h5>
            <button 
              className="btn-close btn-close-white d-md-none" 
              onClick={toggleSidebar}
              aria-label="关闭"
            ></button>
          </div>
          
          {/* 用户信息 */}
          <div className="sidebar-user p-3 border-bottom">
            <div className="d-flex align-items-center">
              <div className="avatar bg-primary text-white rounded-circle d-flex justify-content-center align-items-center me-3" style={{ width: 40, height: 40 }}>
                {currentUser?.name?.charAt(0) || 'U'}
              </div>
              <div className="user-info">
                <h6 className="mb-0 text-white">{currentUser?.name || '用户'}</h6>
                <small className="text-light">{currentUser?.email || ''}</small>
              </div>
            </div>
          </div>
          
          {/* 导航菜单 */}
          <nav className="sidebar-nav flex-grow-1 p-3">
            <ul className="nav nav-pills flex-column">
              {menuItems.map((item, index) => (
                <li className="nav-item mb-2" key={index}>
                  <Link
                    to={item.path}
                    className={`nav-link d-flex align-items-center ${isActive(item.path) ? 'active' : ''}`}
                    onClick={isOpen && window.innerWidth < 768 ? toggleSidebar : undefined}
                  >
                    <span className="nav-icon me-3">{item.icon}</span>
                    <span className="nav-text">{item.title}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          
          {/* 侧边栏底部 */}
          <div className="sidebar-footer p-3 border-top">
            <button 
              className="btn btn-outline-danger w-100 d-flex align-items-center"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="me-2" />
              退出登录
            </button>
          </div>
        </div>
      </div>
      
      {/* 移动端侧边栏遮罩层 */}
      {isOpen && window.innerWidth < 768 && (
        <div 
          className="sidebar-backdrop"
          onClick={toggleSidebar}
        ></div>
      )}
    </>
  );
};

export default Sidebar;